import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper/modules";
import "swiper/swiper-bundle.css";
import Aos from "aos";
import "aos/dist/aos.css"; // AOS CSS
//import promotion from "../../resources/img/promotions-241104.jpg";
import $ from "jquery";
import "../../resources/js/jquery.rwdImageMaps.js";

const StartUp = () => {
  const swiperRef = useRef(null);
  const [position, setPosition] = useState(1065); // 초기 위치 1062px
  const [isMobile, setIsMobile] = useState(false); // 화면이 1250px 이하일 때 여부

  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("open"); // 초기 탭

  const handleTabClick = (tabName) => {
    setActiveTab(tabName); // 클릭한 탭으로 활성화 변경
  };

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 아소비 창업`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });

    // IP 체크 함수
    const checkIP = async () => {
      const response = await fetch("/check-ip");
      const result = await response.json();

      // 리다이렉션 확인
      if (result.redirect) {
        navigate(result.redirect); // navigate로 리다이렉션
      }
    };

    checkIP(); // IP 체크 함수 호출

    Aos.init(); // AOS 초기화

    // DOM 렌더링 후 rwdImageMaps 초기화
    $("img[usemap]").rwdImageMaps();
  }, [location, navigate]); // navigate 추가

  useEffect(() => {
    const handleResize = () => {
      // 화면 너비가 962px 이하일 때만 활성화
      if (window.innerWidth >= 1252) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    // 리사이즈 이벤트 리스너 추가
    window.addEventListener("resize", handleResize);

    // 초기 화면 크기 체크
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isMobile) {
      const swiperWrapper = swiperRef.current?.swiper?.wrapperEl;

      // 처음 렌더링 시에도 위치를 설정 (1062px)
      if (swiperWrapper) {
        swiperWrapper.style.transform = `translate3d(${position}px, 0, 0)`;
      }

      const handleWheel = (event) => {
        // 마우스 휠 이벤트가 Swiper 영역에서만 반응하도록 처리
        if (swiperRef.current && swiperRef.current.swiper) {
          // Swiper 내부에서만 이벤트 처리
          const swiperContainer = swiperRef.current.swiper.el;
          if (swiperContainer.contains(event.target)) {
            let newPosition = position;

            // 마우스 휠 내릴 때, -1061px
            if (event.deltaY > 0) {
              newPosition -= 1061;
            } else if (event.deltaY < 0) {
              // 마우스 휠 올릴 때, +1601px
              newPosition += 1601;
            }

            // 새로운 위치가 1062px을 넘지 않도록 제한
            if (newPosition > 1065) {
              newPosition = 1065;
            }

            // 위치를 변환
            swiperWrapper.style.transform = `translate3d(${newPosition}px, 0, 0)`;

            // position state 업데이트
            setPosition(newPosition);
          }
        }
      };

      // 마우스 휠 이벤트 리스너 추가
      window.addEventListener("wheel", handleWheel, { passive: true });

      // Cleanup
      return () => {
        window.removeEventListener("wheel", handleWheel);
      };
    }
    console.log("Swiper Initialized");
  }, [isMobile, position]); // 화면 크기와 position이 변경될 때마다 실행
  
  useEffect(() => {
    const swiperElements = document.querySelectorAll(".swiper-backface-hidden");
    swiperElements.forEach((el) =>
      el.classList.remove("swiper-backface-hidden")
    );
  }, []);

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/startUp" className="sel">
                  아소비 창업
                </a>
              </li>
              <li>
                <a href="/startInfo">창업 안내</a>
              </li>
              <li>
                <a href="/startProcess">창업 절차</a>
              </li>
              <li>
                <a href="/benefit">지원 혜택</a>
              </li>
              <li>
                <a href="/asobimanager">아소비 지사장</a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="startup">
          <div className="section">
      {/* <div className="section00">
              <div className="img">
                <img
                  src={promotion}
                  useMap="#main_map"
                  className="top_main_img"
                  alt="Promotional"
                />
                <map name="main_map">
                  <area
                    target="_blank"
                    alt="Asobi"
                    title="자세히 보기"
                    href="https://asobi24.gabia.io/"
                    coords="789,863,1144,960"
                    shape="rect"
                  />
                </map>
              </div>
            </div>*/}
            {/* <div className="section01">
              <div className="img">
                <img src={promotion} className="top_main_img" alt="" />
                <img src={promotion} className="top_main_img_mo" alt="" />
              </div>
            </div> */}
            <div className="section02">
              <div
                className="sec2_wrap"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <h3>
                  나도 <span>일하고 싶다!</span>
                </h3>
                <iframe
                  width="800"
                  height="400"
                  src="https://www.youtube.com/embed/TNJ09L015m8"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <div className="section03">
              <div
                className="sec3_wrap"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <h3>
                  <img src="../custom-resources/images/con_tit.png" alt="" />
                  <br />
                  2,000명이 넘는 원장님들이
                  <br />
                  <span>아소비를</span> 선택한 이유!
                </h3>
                <div className="sec3_img">
                  <ul>
                    {/* <li><img src="../custom-resources/images/section4_01.png" alt=""></li> */}
                    <li>
                      <img
                        src="../custom-resources/images/section4_02.png"
                        alt=""
                      />
                    </li>
                    <li>
                      <img
                        src="../custom-resources/images/section4_03.png"
                        alt=""
                      />
                    </li>
                    <li>
                      <img
                        src="../custom-resources/images/section4_04.png"
                        alt=""
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="section04">
              <div
                className="sec3_wrap"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <h3>
                  전국 <span>2,000호점</span> 돌파한 아소비
                </h3>
                <p>아소비 교육원 증가의 수치가 증명해줍니다!</p>
                <img src="../custom-resources/images/graph.png" alt="" />
              </div>
            </div>
            <div className="section05">
              <div
                className="sec3_wrap"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <h3>
                  합리적인 투자비용, <span>높은 수익률 보장!</span>
                </h3>
                <p>
                  타 브랜드와 달리 교육원 회원이 납입하는 월 교육비 전액이
                  <br />
                  원장님 수익이 되기 때문에 높은 수익률을 기대할 수 있습니다.
                </p>
                <table className="tg">
                  <thead>
                    <tr>
                      <th className="tg-gvau">구분</th>
                      <th className="tg-60pk">아소비</th>
                      <th className="tg-gvau">A사</th>
                      <th className="tg-gvau tg-4none">B사</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="tg-xyi7">교육대상</td>
                      <td className="tg-16ok">유치 (5~7세) / 초등 1,2학년</td>
                      <td className="tg-xyi7">유아 ~ 초등 6년</td>
                      <td className="tg-xyi7 tg-4none">초등 ~ 중등</td>
                    </tr>
                    <tr>
                      <td className="tg-xyi7">학습 시스템</td>
                      <td className="tg-16ok">
                        특허받은 한글교재
                        <br />
                        아동발달 과정에 맞춘 유기농 교육
                      </td>
                      <td className="tg-xyi7">태블릿PC를 활용한 디지털 교육</td>
                      <td className="tg-xyi7 tg-4none">
                        전 과목/각종 단 과목 프로그램
                        <br />
                        인터넷강의, 동영상 강좌
                      </td>
                    </tr>
                    <tr>
                      <td className="tg-xyi7">창업 비용</td>
                      <td className="tg-16ok">
                        319만원 (가입비, 교육비, 초도물품비 포함)
                      </td>
                      <td className="tg-xyi7">가맹비 없음</td>
                      <td className="tg-xyi7 tg-4none">가맹비 없음</td>
                    </tr>
                    <tr>
                      <td className="tg-xyi7">수익 체계</td>
                      <td className="tg-16ok">
                        수수료 (교육비 전액이 원장 수익)
                      </td>
                      <td className="tg-xyi7">
                        운영 실적, 직급별 수수료 지불
                        <br />
                        (본사 : 원장 = 약 6 : 4)
                      </td>
                      <td className="tg-xyi7 tg-4none">
                        01 ~19과목 : 60% 수수료 지불
                        <br />
                        20과목 이상 : 65% 수수료 지불
                        <br />
                        35과목 이상 : 75% 수수료 지불
                      </td>
                    </tr>
                    <tr>
                      <td className="tg-xyi7">운영 시스템</td>
                      <td className="tg-16ok">주 4일, 일 평균 4~5시간 수업</td>
                      <td className="tg-xyi7">
                        실적에 대한 압박, 주 2회 지국 출근
                      </td>
                      <td className="tg-xyi7 tg-4none">
                        다 과목/다시간 수업유도
                        <br />
                        주말수업, 성적 압박의 피로감
                      </td>
                    </tr>
                    <tr>
                      <td className="tg-xyi7">운영 비용</td>
                      <td className="tg-16ok">
                        창업 비용 외 본사 지불 비용 없음
                      </td>
                      <td className="tg-xyi7">
                        태블릿PC 대여비용
                        <br />
                        <span>
                          교사용 44,000원 x 06개월
                          <br />
                          학생용 44,000원 x 24개월
                        </span>
                      </td>
                      <td className="tg-xyi7 tg-4none">
                        회원 모집책에 수수료 추가 납부
                      </td>
                    </tr>
                    <tr>
                      <td className="tg-xyi7">원생 교육비</td>
                      <td className="tg-16ok">187,000원 ~ (교재비 포함)</td>
                      <td className="tg-xyi7">
                        교육비 외 디지털 콘텐츠
                        <br />
                        구입비용 추가 발생
                      </td>
                      <td className="tg-xyi7 tg-4none">
                        교육비 원장 결정
                        <br />
                        (상담 역력별 수익 변동)
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p className="con_list">※ 공부방 창업 기준입니다.</p>
              </div>
            </div>
            <div className="section06">
              <div
                className="sec3_wrap sec6_wrap"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <h3>아파트부터 학원형까지, 다양한 선택지!</h3>
                <p>
                  아소비 공부방은 아파트 공부방 외에도 단독학원, 샵인샵 등<br />
                  다양한 형태의 학원형 운영이 가능합니다.
                </p>
                <table className="tg">
                  <thead>
                    <tr>
                      <th className="tg-8ii9">구분</th>
                      <th className="tg-gmx8">아소비 단독학원</th>
                      <th className="tg-gmx8">기존 학원(shop in shop 형태)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="tg-iglv">영업지역</td>
                      <td className="tg-iglv">3,000 세대</td>
                      <td className="tg-lzaa">
                        1교실 당 1,000세대 (최대 3,000세대)
                      </td>
                    </tr>
                    <tr>
                      <td className="tg-iglv">자격조건</td>
                      <td className="tg-lzaa"></td>
                      <td className="tg-3pow">
                        <div className="tg-p">
                          동일한 교육 대상의 경우
                          <br />- 과목이 다른 보습학원 가능
                          <br />
                          <br />
                          교육 대상이 상이한 경우
                          <br />- 동일 보습과목 학원 가능
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="p_line">
                  <p>
                    ※ 샵인샵의 경우 구체적인 가맹조건은 상담을 통해 확인하시기
                    바랍니다!
                  </p>
                </div>
                <img
                  className="sec06_bg1"
                  src="../custom-resources/images/con_bg01.png"
                  alt=""
                />
                <img
                  className="sec06_bg2"
                  src="../custom-resources/images/con_bg02.png"
                  alt=""
                />
              </div>
            </div>

            <div className="section07">
              <div
                className="sec3_wrap sec6_wrap"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <h3>
                  <span className="top_br">
                    우리 동네 최고의 공부방이 되기까지
                  </span>
                  <br />
                  본사의 확실한 <span className="n_yellow">창업지원</span>
                </h3>
                <div className="sec7_tab">
                  <div className="tab">
                    <button
                      className={`tablinks tab01 ${
                        activeTab === "open" ? "active" : ""
                      }`}
                      onClick={() => handleTabClick("open")}
                    >
                      오픈지원
                    </button>
                    <button
                      className={`tablinks tab02 ${
                        activeTab === "education" ? "active" : ""
                      }`}
                      onClick={() => handleTabClick("education")}
                    >
                      교육지원
                    </button>
                    <button
                      className={`tablinks tab03 ${
                        activeTab === "operation" ? "active" : ""
                      }`}
                      onClick={() => handleTabClick("operation")}
                    >
                      운영지원
                    </button>
                    <button
                      className={`tablinks tab04 ${
                        activeTab === "promotion" ? "active" : ""
                      }`}
                      onClick={() => handleTabClick("promotion")}
                    >
                      홍보지원
                    </button>
                    <button
                      className={`tablinks tab05 ${
                        activeTab === "product" ? "active" : ""
                      }`}
                      onClick={() => handleTabClick("product")}
                    >
                      초도물품지원
                    </button>
                  </div>
                  <div
                    id="open"
                    className={`tabcontent tabcon_01 ${
                      activeTab === "open" ? "active" : ""
                    }`}
                  >
                    <h3>
                      오픈 준비 어렵다? <span className="tit_blue">NO!</span>
                    </h3>
                    <p>아소비 본사, 지사의 든든한 지원!</p>
                    <div className="tab_list">
                      <ul>
                        <li>
                          <img
                            src="../custom-resources/images/check.png"
                            alt=""
                          />
                          복잡하고 까다로운 교육청 신고? 창업 전문가 '아소비
                          지사'의 지원으로 일사천리 진행!
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/check.png"
                            alt=""
                          />
                          인테리어 비용? NO! 인테리어 제한 없이 기존 물품 재사용
                          가능!
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/check.png"
                            alt=""
                          />
                          본사와 다양한 업체와의 협업으로 오픈에 필요한 물품
                          시중보다 저렴하게 구매 가능!
                        </li>
                      </ul>
                    </div>
                    <div className="tab_img">
                      <img src="../custom-resources/images/tab01.png" alt="" />
                      <img src="../custom-resources/images/tab02.png" alt="" />
                    </div>
                  </div>
                  <div
                    id="education"
                    className={`tabcontent tabcon_02 ${
                      activeTab === "education" ? "active" : ""
                    }`}
                  >
                    <h3>
                      여러분을{" "}
                      <span className="tit_blue">5~9세 교육 전문가</span>
                      <br />
                      <span className="tit_size">로 만들어 드립니다!</span>
                    </h3>
                    <div className="tab_list">
                      <ul>
                        <li>
                          <img
                            src="../custom-resources/images/check.png"
                            alt=""
                          />
                          본사 가맹교육, OJT 교육 4일, 지사교육, 정기교육 등
                          교육 프로그램 진행
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/check.png"
                            alt=""
                          />
                          가맹 후 아소비 교육 이념 현장 적용에 어려움이 없도록
                          지속적인 교육시행
                        </li>
                      </ul>
                    </div>
                    <div className="tab2_img">
                      <ul>
                        <li>
                          <img
                            src="../custom-resources/images/tab2_01.png"
                            alt=""
                          />
                          대표이사 온라인 강의
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/tab2_03.png"
                            alt=""
                          />
                          아소비 아카데미
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/tab2_02.png"
                            alt=""
                          />
                          연차별 심화 교육
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    id="operation"
                    className={`tabcontent tabcon_03 ${
                      activeTab === "operation" ? "active" : ""
                    }`}
                  >
                    <h3>
                      지속적인{" "}
                      <span className="tit_blue">교육원 운영 동기 부여</span>
                      <br />
                      <span className="tit_size">및 다양한 운영지원</span>
                    </h3>
                    <div className="tab_list">
                      <ul>
                        <li>
                          <img
                            src="../custom-resources/images/check.png"
                            alt=""
                          />
                          오래도록 만족스러운 교육원 운영을 할 수 있도록 다양한
                          이벤트를 통해 지원
                        </li>
                      </ul>
                    </div>
                    <div className="tab2_img tab3_img">
                      <ul>
                        <li>
                          <img
                            src="../custom-resources/images/tab3_01.png"
                            alt=""
                          />
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/tab3_02.png"
                            alt=""
                          />
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/tab3_03.png"
                            alt=""
                          />
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/tab3_04.png"
                            alt=""
                          />
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/tab3_05.png"
                            alt=""
                          />
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/tab3_06.png"
                            alt=""
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    id="promotion"
                    className={`tabcontent tabcon_04 ${
                      activeTab === "promotion" ? "active" : ""
                    }`}
                  >
                    <h3>
                      <span className="tit_blue">우리동네 최고 교육원</span>이
                      <br />
                      <span className="tit_size">
                        될 때까지 아낌없는 홍보지원
                      </span>
                    </h3>
                    <div className="tab_list">
                      <ul>
                        <li>
                          <img
                            src="../custom-resources/images/check.png"
                            alt=""
                          />
                          SBS, EBS 등 공중파 TV 광고, 라디오 광고 진행
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/check.png"
                            alt=""
                          />
                          네이버, 구글, 카카오 키워드, 배너 광고 진행
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/check.png"
                            alt=""
                          />
                          유튜브 채널 운영으로 바이럴마케팅 진행
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/check.png"
                            alt=""
                          />
                          학부모 설명회 개최, 파라솔 홍보, 연합 홍보 지원
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/check.png"
                            alt=""
                          />
                          유아교육전 참가
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/check.png"
                            alt=""
                          />
                          판촉물 제작 및 지원
                        </li>
                      </ul>
                    </div>
                    <div className="tab2_img">
                      <ul>
                        <li>
                          <img
                            src="../custom-resources/images/tab4_01.png"
                            alt=""
                          />
                          TV 광고
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/tab4_02.png"
                            alt=""
                          />
                          네이버 광고
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/tab4_03.png"
                            alt=""
                          />
                          학부모 설명회 개최
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    id="product"
                    className={`tabcontent tabcon_05 ${
                      activeTab === "product" ? "active" : ""
                    }`}
                  >
                    <h3>
                      가맹 전 지점에게
                      <br />
                      제공되는 <span className="tit_blue">초도물품!</span>
                    </h3>
                    <div className="tab_list">
                      <ul>
                        <li>
                          <img
                            src="../custom-resources/images/check.png"
                            alt=""
                          />
                          아소비 가맹비용에는 초도물품비가 포함!
                        </li>
                        <li>
                          <img
                            src="../custom-resources/images/check.png"
                            alt=""
                          />
                          샘플 교재, 각종 홍보물품, 아소비만을 위해 공방에서
                          수작업으로 제작되는 원목 교구장
                        </li>
                      </ul>
                    </div>
                    <div className="tab5_img">
                      <img src="../custom-resources/images/tab5.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="section08">
              <div
                className="sec3_wrap sec8_wrap"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <h3>
                  <img src="../custom-resources/images/youtube.png" alt="" />
                  <br />
                  <span className="top_br">우리 동네 최고의 아소비</span>
                  <br />
                  원장님이 들려주는
                  <br />
                  <span className="n_blue">솔직한 창업 후기</span>
                </h3>
                <div className="video_wrap">
                  <iframe
                    width="580"
                    height="315"
                    src="https://www.youtube.com/embed/LMhV0-Es0EQ"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                  <iframe
                    width="580"
                    height="315"
                    src="https://www.youtube.com/embed/TRro5bY7hwU"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>

              <div
                className="sec10_wrap"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <div className="sec10_text">
                  <h4>아소비 교육원 개설 승인 조건</h4>
                  <div
                    className="sec9_wrap"
                    data-aos="fade-up"
                    data-aos-duration="2000"
                  >
                    <div className="sec9_text">
                      <p>
                        아소비는 교육 프랜차이즈로 전국에 모든 아소비 아이들에게
                        <br />
                        동일한 교육 서비스를 제공하는 시스템 교육 기업입니다.
                      </p>
                      <h4>아소비와 함께 할 교육 전문가를 기다립니다.</h4>
                    </div>
                  </div>
                  <div className="sec10_box">
                    <ul>
                      <li>
                        <p>
                          <strong>나이</strong>45세 이하
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>학력</strong>초대졸 이상
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>경력</strong>교육전공자(경력 제한 없음)
                          <br />
                          교육비전공자(관련 업종 경력 1년 이상)
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="sec11_wrap"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <div className="sec11_box">
                  <div className="box_left">
                    <img
                      src="../custom-resources/images/con_nam_img.png"
                      alt=""
                    />
                  </div>
                  <div className="box_right">
                    <h4>우대사항</h4>
                    <ul>
                      <li>
                        <img src="../custom-resources/images/num1.png" alt="" />
                        아이들의 행복한 배움의 시작을 위해 노력할 분
                      </li>
                      <li>
                        <img src="../custom-resources/images/num2.png" alt="" />
                        아소비 교육 철학 '유기농 공부'와 함께할 분
                      </li>
                      <li>
                        <img src="../custom-resources/images/num3.png" alt="" />
                        아소비 운영 메뉴얼을 준수해 나아갈 분
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="section09">
              <div
                className="sec3_wrap sec8_wrap"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <h3>아소비 개설 프로세스</h3>
                <p>
                  아소비 가맹 프로세스를 통해 누구보다 든든한 창업의 길을
                  열어드립니다.
                  <br />
                  보다 자세한 사항은 본사 (1688-1993) 전화 또는 고객센터 상담
                  메뉴를
                  <br />
                  이용하셔서 확인하시기 바랍니다.
                </p>
              </div>
              <div className="sec9_scroll">
                <div className="slider">
				<Swiper
				  setWrapperSize={false}
				  centeredSlides={true}
				  roundLengths={true}
				  mousewheel={true} // Mousewheel 기능을 활성화
				  modules={[Mousewheel]} // Mousewheel 모듈을 활성화
				  breakpoints={{
				    320: {
				      spaceBetween: 1,
				      slidesPerView: 1,
				    },
				    1024: {
				      spaceBetween: 3,
				      slidesPerView: 3,
				    },
				  }} // 화면 크기에 따라 설정 변경
				  onSlideChange={() => {
				    setTimeout(() => {
				      console.log("Slide Changed");
				    }, 500);
				  }}
				  onReachEnd={() => {
				    setTimeout(() => {
				      console.log("Reached End");
				    }, 750);
				  }}
				  onSwiper={(swiper) => {
				    const removeBackfaceHidden = () => {
				      if (swiper && swiper.el) {
				        swiper.el.classList.remove("swiper-backface-hidden");
				      }
				    };

				    // 초기화 시 제거
				    removeBackfaceHidden();

				    // 리사이즈 이벤트
				    swiper.on("resize", removeBackfaceHidden);

				    // 브레이크포인트 변경 시
				    swiper.on("breakpoint", removeBackfaceHidden);

				    // 슬라이드 변경 시
				    swiper.on("slideChange", removeBackfaceHidden);

				    // Swiper 업데이트 시
				    swiper.on("update", removeBackfaceHidden);
				  }}
				>
                    <SwiperSlide role="group" aria-label="1 / 9">
                      <em>01</em>
                      <i>
                        <img
                          src="../custom-resources/images/img_startProcess_startProcess02_img01.png"
                          alt=""
                        />
                      </i>
                      <span>본사/지사 전화상담</span>
                    </SwiperSlide>
                    <SwiperSlide>
                      <em>02</em>
                      <i>
                        <img
                          src="../custom-resources/images/img_startProcess_startProcess02_img02.png"
                          alt=""
                        />
                      </i>
                      <span>대면상담</span>
                    </SwiperSlide>
                    <SwiperSlide>
                      <em>03</em>
                      <i>
                        <img
                          src="../custom-resources/images/img_startProcess_startProcess02_img03.png"
                          alt=""
                        />
                      </i>
                      <span>
                        정보공개서/가맹계약서 인근가맹점 현황문서 수령
                      </span>
                    </SwiperSlide>
                    <SwiperSlide>
                      <em>04</em>
                      <i>
                        <img
                          src="../custom-resources/images/img_startProcess_startProcess02_img04.png"
                          alt=""
                        />
                      </i>
                      <span>가맹계약서 작성</span>
                    </SwiperSlide>
                    <SwiperSlide>
                      <em>05</em>
                      <i>
                        <img
                          src="../custom-resources/images/img_startProcess_startProcess02_img05.png"
                          alt=""
                        />
                      </i>
                      <span>
                        가맹예치금,
                        <br className="pc-view" />
                        초도물품비 입금
                      </span>
                    </SwiperSlide>
                    <SwiperSlide>
                      <em>06</em>
                      <i>
                        <img
                          src="../custom-resources/images/img_startProcess_startProcess02_img06.png"
                          alt=""
                        />
                      </i>
                      <span>본사 및 지사 가맹 교육 수료</span>
                    </SwiperSlide>
                    <SwiperSlide>
                      <em>07</em>
                      <i>
                        <img
                          src="../custom-resources/images/img_startProcess_startProcess02_img07.png"
                          alt=""
                        />
                      </i>
                      <span>참관수업 실시</span>
                    </SwiperSlide>
                    <SwiperSlide>
                      <em>08</em>
                      <i>
                        <img
                          src="../custom-resources/images/img_startProcess_startProcess02_img08.png"
                          alt=""
                        />
                      </i>
                      <span>학부모 설명회 개최</span>
                    </SwiperSlide>
                    <SwiperSlide>
                      <em>09</em>
                      <i>
                        <img
                          src="../custom-resources/images/img_startProcess_startProcess02_img09.png"
                          alt=""
                        />
                      </i>
                      <span>개원</span>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>

            <div className="section10">
              <div className="con10_wrap">
                <div className="sec10_left">
                  <button>
                    <a href="https://www.asobi.co.kr/jsp/oneonone.jsp?ty_para=2">
                      무료 창업 상담 신청하기
                    </a>
                  </button>
                  <button className="btn_0">
                    <a href="https://www.asobi.co.kr/jsp/startProcess.jsp">
                      창업설명회 일정 확인하기
                    </a>
                  </button>
                </div>
                <div className="sec10_right">
                  <img
                    src="../custom-resources/images/con_nam_img2.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default StartUp;
